import { render } from "./MenuMain.vue?vue&type=template&id=3fc78a5c&scoped=true"
import script from "./MenuMain.vue?vue&type=script&lang=js"
export * from "./MenuMain.vue?vue&type=script&lang=js"

import "./MenuMain.vue?vue&type=style&index=0&id=3fc78a5c&scoped=true&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc78a5c"]])

export default __exports__